export default import.meta.ROLLDOWN_FILE_URL_GRdaSMU9EykDMf$v0bZXbA